/**
 * Enable public surfaces (e.g. POS marketing page) to drive adoption
 */
export const ENABLE_DRIVE_POS_ADOPTION_PUBLIC_SURFACES_240529 = 'ENABLE_DRIVE_POS_ADOPTION_PUBLIC_SURFACES_240529';
